import query from 'devextreme/data/query';
import * as glb from '../globals.js';

/** Para ekranı rolleri — SABIT ST_TUR=130 ST_KODINT */
export const PARA_KUL_STATU = Object.freeze({
  EKIP: 1,
  GORUSEN: 2,
  MUS_TEM: 3,
  REKLAMCI: 5,
  HEMSIRE: 6,
});

const KUL_STATU_SEP = ',';

/** Virgülle ayrılmış statü kodlarını sayı dizisine çevirir (boş/tekrar yok). */
export function parseKulStatuList(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) {
    return [...new Set(value.map((x) => Number(x)).filter((n) => Number.isFinite(n)))];
  }
  const raw = String(value).trim();
  if (!raw) return [];
  return [...new Set(
    raw.split(KUL_STATU_SEP)
      .map((part) => part.trim())
      .filter(Boolean)
      .map((part) => Number(part))
      .filter((n) => Number.isFinite(n))
  )];
}

/** Statü kodlarını veritabanı alanı formatına çevirir. */
export function formatKulStatuList(values) {
  const list = parseKulStatuList(values);
  if (!list.length) return null;
  return list.join(KUL_STATU_SEP);
}

/** Kullanıcının verilen statü kodlarından en az birine sahip olup olmadığı. */
export function kulStatuMatches(kulStatu, expectedStatu) {
  if (expectedStatu == null || expectedStatu === '') return true;
  const expected = Number(expectedStatu);
  if (!Number.isFinite(expected)) return false;
  const list = parseKulStatuList(kulStatu);
  if (!list.length) return false;
  return list.includes(expected);
}

/** Tek statü veya dizi — herhangi biri eşleşirse true. */
export function kulStatuMatchesAny(kulStatu, expectedList) {
  const arr = Array.isArray(expectedList) ? expectedList : [expectedList];
  if (!arr.length) return true;
  return arr.some((s) => kulStatuMatches(kulStatu, s));
}

export function filterKullanicilarByStatu(kullanicilar, statu) {
  const list = Array.isArray(kullanicilar) ? kullanicilar : [];
  if (statu == null || statu === '') return list;
  return list.filter((k) => kulStatuMatches(k?.KUL_STATU, statu));
}

export function getKulStatuSabitItems() {
  return query(glb.default.sabitLkp).filter((x) => x.ST_TUR === 130).toArray();
}

/** Grid / liste için statü adlarını virgülle birleştirir. */
export function formatKulStatuDisplay(kulStatu, sabitItems) {
  const items = sabitItems || getKulStatuSabitItems();
  const codes = parseKulStatuList(kulStatu);
  if (!codes.length) return '';
  const byCode = new Map(
    (items || []).map((x) => [Number(x.ST_KODINT), x.ST_AD])
  );
  return codes
    .map((code) => byCode.get(code) || String(code))
    .filter(Boolean)
    .join(', ');
}

/** Form TagBox değeri (ST_KODINT dizisi). */
export function kulStatuToTagValue(kulStatu) {
  return parseKulStatuList(kulStatu);
}

/** TagBox seçiminden kayıt alanına. */
export function kulStatuFromTagValue(tagValue) {
  return formatKulStatuList(tagValue);
}
